export default ({
  dashboard_personal: {
    icon: 'person',
    title: 'Pessoal'
  },
  dashboard_management: {
    icon: 'group',
    title: 'Gestão de Pessoas'
  },
  dashboard_movement: {
    icon: 'fas fa-chart-pie',
    title: 'Movimentação'
  }
})



// WEBPACK FOOTER //
// ./src/translate/pt_br/dashboard.js